/*
 * Редактирование кейсета - https://tanker.yandex-team.ru/project/direct-components/keyset/components%2FTable%2FButton%2FButton.i18n.ts
 * Документация локализации - https://a.yandex-team.ru/arcadia/adv/frontend/docs/monorepo/i18n.md
 */
import { createI18n, createI18nRaw, createKeyset } from '@adv-frontend/l10n/src/i18n';
const keyset = createKeyset({
    Добавить: {
        ru: 'Добавить',
        en: 'Add',
        tr: 'Ekle',
        'zh-Hans': '添加',
    },
});
export const i18n = createI18n(keyset);
export const i18nRaw = createI18nRaw(keyset);
